<template>
  <main role="main" class="main bg-navy">
    <div class="bg-navy d-block d-md-none">
      <b-row class="no-gutters">
        <b-col class="text-center">
          <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
            <feather type="arrow-left"></feather>
          </b-button>
          <span class="d-inline-block h-100 title-w-60">
            <span class="d-table h-100">
              <span class="d-table-cell align-middle">
                <strong class="color-white">Organisational Details</strong>
              </span>
            </span>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mobile-vh min-h-100 p-4 p-md-5 bg-white mobi-rounded-top">
      <b-row class="custom-height">
        <b-col lg="10" offset-lg="1">
          <profile-menu></profile-menu>
          <h2 class="mobile-size-reduce color-navy-blue mb-3">Organisational Details</h2>
          <h5 class="mb-3 d-none d-md-block"><strong class="color-navy-blue">Please note:</strong> When updating these details your organisation profile will automatically be reverified.</h5>
          <p class="mb-3 d-block d-md-none"><strong class="color-navy-blue">Please note:</strong> When updating these details your organisation profile will automatically be reverified.</p>
          <b-row class="mb-2 mt-4">
            <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-select v-model="company.company_type" placeholder="Business Type" clearable required :success="company.company_type !== null && company.company_type !== ''" :options="businessStore.Types.map(_record => ({ value: _record, label: _record }))"></maz-select>
            </b-col>
            <b-col md="6" class="pl-lg-0">
              <maz-input v-model="company.name" placeholder="Registered Name" required :success="company.name && company.name.length >= 2"></maz-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-input v-model="company.reg_number" placeholder="Registered Number" required :success="company.reg_number && company.reg_number.length >= 2"></maz-input>
            </b-col>
            <b-col md="6" class="pl-lg-0">
              <maz-input v-model="company.vat_number" placeholder="Tax / VAT Number" :success="company.vat_number && company.vat_number.length >= 2"></maz-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-input v-model="company.trading_name" placeholder="Operating / Trading Name" required :success="company.trading_name && company.trading_name >=2"></maz-input>
            </b-col>
            <b-col md="6" class="pl-lg-0">
              <maz-select v-model="company.country" placeholder="Country of Establishment" clearable required :success="company.country !== null && company.country !== ''" :options="countries.map(_country => ({ value: _country.code, label: _country.name }))"></maz-select>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-select v-model="company.status" placeholder="Business Status" clearable required :success="company.status !== null && company.status !== ''" :options="businessStore.Statuses.map(_type => ({ value: _type, label: _type }))"></maz-select>
            </b-col>
            <b-col md="6" class="pl-lg-0">
              <maz-select v-model="company.industry" placeholder="Industry" clearable required :success="company.industry !== null && company.industry !== ''" :options="industries.map(_industry => ({ value: _industry, label: _industry }))"></maz-select>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-input v-model="company.address" placeholder="Registered Address" required :success="company.address && company.address >= 2"></maz-input>
            </b-col>
            <b-col md="6" class="pl-lg-0">
              <maz-input v-model="company.trading_address" placeholder="Operating / Trading Address" required :success="company.trading_address && company.trading_address >= 2"></maz-input>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0 mb-2 mb-lg-0">
              <maz-input v-model="company.email" placeholder="Email Address" :success="company.email && company.email >= 2"></maz-input>
            </b-col>
            <b-col md="6" class="pl-lg-0">
              <maz-input v-model="company.website" placeholder="Website Address" :success="company.website && company.website >= 2"></maz-input>
            </b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0">
              <maz-input v-model="company.phone" placeholder="Office Number" :success="company.phone && company.phone >= 2"></maz-input>
            </b-col>
          </b-row>

          <!-- <b-row class="mb-2">
            <b-col md="6" class="pl-lg-0">
              <maz_input v-model="company.phone" placeholder="Office number" :success="company.phone && company.phone >= 2"></maz_input>
            </b-col>
          </b-row> -->

          <b-row>
            <b-form-group class="col-xl-12 btn-bottom px-md-0">
              <b-row>
                <b-col lg="6" offset-lg="6" cols="12">
                  <loading-button :replace="saving === true">
                    <b-button variant="custom"  @click="save()" pill block class="mt-3" :disabled="myRole !== 'Administrators'">Save</b-button>
                  </loading-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import ProfileMenu from '@/components/organisation/ProfileMenu'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    ProfileMenu
  },
  data () {
    return {
      saving: false,
      company: {
        company_type: null,
        name: null,
        trading_name: null,
        reg_number: null,
        vat_number: null,
        address: null,
        trading_address: null,
        country: 'ZA',
        status: 'In Business',
        industry: null,
        phone: null,
        email: null,
        website: null,
        invoice: {
          enabled: false
        }
      },
      company_schema: {
        fields: [
          {
            type: 'select',
            placeholder: 'Company Type',
            model: 'company_type',
            values: (model, schema) => {
              const _companies = []
              this.businessStore.Types.forEach(type => {
                _companies.push({ id: type, name: type })
              })
              return _companies
            },
            selectOptions: {
              noneSelectedText: 'Company type',
              hideNoneSelectedText: false
            },
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Company Name',
            model: 'name',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Registration Number',
            model: 'reg_number',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Tax / VAT Number',
            model: 'vat_number',
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Operating / Trading Name',
            model: 'trading_name',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Country of Establishment',
            model: 'country',
            values: (model, schema) => {
              const _countries = []
              this.countries.forEach(country => {
                _countries.push({ id: country.code, name: country.name })
              })
              return _countries
            },
            required: true,
            selectOptions: {
              noneSelectedText: 'Country of Establishment',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Business Status',
            model: 'status',
            values: (model, schema) => {
              const _companies = []
              this.businessStore.Statuses.forEach(type => {
                _companies.push({ id: type, name: type })
              })
              return _companies
            },
            selectOptions: {
              noneSelectedText: 'Business status',
              hideNoneSelectedText: false
            },
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Industry',
            model: 'industry',
            values: (model, schema) => {
              const _industries = []
              this.industries.forEach(industry => {
                _industries.push(industry)
              })
              return _industries
            },
            required: true,
            validator: ['required'],
            selectOptions: {
              noneSelectedText: 'Industry',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Registered Address',
            model: 'address',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Operating / Trading Address',
            model: 'trading_address',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'email',
            placeholder: 'Email Address',
            model: 'email',
            validator: ['email'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Website Address',
            model: 'website',
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'tel-input',
            label: 'Office number',
            placeholder: 'Office Number',
            model: 'phone',
            validator: ['telNumber'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      formOptions: {
        validationErrorClass: 'has-error',
        validationSuccessClass: 'has-success',
        validateAfterChanged: false,
        validateAsync: true
      },
      action: null,
      data: null
    }
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      auth: state => state.auth.user,
      businessStore: state => state.business,
      countries: state => state.country.countries,
      industries: state => state.industries.industry,
      companies: state => state.company
    }),
    companyLoaded () {
      return this.companies.status
    },
    myRole () {
      if (this.auth && this.auth.user && this.auth.user.role) {
        return this.auth.user.role.name
      } else {
        return 'Unknown'
      }
    }
  },
  methods: {
    ...mapActions('company', {
      getCompany: 'get',
      saveCompany: 'save'
    }),
    save: async function () {
      this.saving = true
      this.saveCompany(this.company)
    }
  },
  mounted () {
    this.getCompany()
  },
  watch: {
    companyLoaded (value) {
      if (value === 'loaded') {
        this.saving = false
        const _company = this.companies.company
        if (_company.phone && _company.phone.charAt(0) === '0') {
          _company.phone = '+27' + _company.phone.substr(1)
        }

        this.company = {
          company_type: _company.company_type,
          name: _company.name,
          trading_name: _company.trading_name,
          reg_number: _company.reg_number,
          vat_number: _company.vat_number,
          address: _company.address,
          trading_address: _company.trading_address,
          country: _company.country || 'ZA',
          status: _company.status || 'In Business',
          industry: _company.industry,
          phone: _company.phone,
          email: _company.email,
          website: _company.website,
          invoice: _company.invoice
        }
      }

      if (value === 'saved') {
        this.getCompany()
      }
    }
  }
}
</script>
